import { PendingOrderApiAdapter } from '../adapters/PendingOrderApiAdapter';
import { PendingOrder, PendingOrderFilters } from '../models/PendingOrder';

export class PendingOrderService {
    constructor(private apiAdapter: PendingOrderApiAdapter) { }

    async getAllPendingOrders(filters: PendingOrderFilters = {}): Promise<PendingOrder[]> {
        return this.apiAdapter.getPendingOrders(filters);
    }
} 